<template>
<div style="margin:20px">
  <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
    <span style="font-size: 26px; font-weight: bold">Actuals - Multiday Ontime Performance Report</span><br/>
    <span style="font-style: italic; font-size: 18px">this report highlights differences between planned & actual times.  Select a base and thresholds and rerun to filter results.</span>
  </div>
  <div class="multiday-otp-filter-rows">
  <div class="multiday-otp-filter-row align-right d-flex align-items-center justify-content-center">
    <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
    &nbsp;<date-picker style="font-size: 16px; font-weight: bold; width:130px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
    &nbsp;to&nbsp;<date-picker style="font-size: 16px; font-weight: bold; width:130px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
    &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
    &nbsp;&nbsp;&nbsp;
    <span v-if="base_options && base_options.length > 2">Base&nbsp;<b-form-select v-model="selected_base" :options="base_options" style="font-size: 16px; font-weight: bold; width:220px"/>&nbsp;&nbsp;</span>
  </div>
  <div class="multiday-otp-filter-row align-right d-flex align-items-center justify-content-center">
    Consecutive Days&nbsp;<b-form-select v-model="consecutive_days_mode" :options="consecutiveDaysModeOptions" style="font-size: 16px; font-weight: bold; width:120px"/>
    &nbsp;&nbsp;
    Days&nbsp;<b-form-select v-model="day_threshold" :options="daysOptions" style="font-size: 16px; font-weight: bold; width:55px"/>
    &nbsp;&nbsp;
    Total Diff &nbsp;<b-form-select v-model="total_threshold" :options="threshold_options" style="font-size: 16px; font-weight: bold; width:80px"/>
    &nbsp;&nbsp;
    Start Diff &nbsp;<b-form-select v-model="start_threshold" :options="threshold_options" style="font-size: 16px; font-weight: bold; width:80px"/>
    &nbsp;&nbsp;
    Finish Diff &nbsp;<b-form-select v-model="finish_threshold" :options="threshold_options" style="font-size: 16px; font-weight: bold; width:80px"/>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <b-button v-on:click.prevent="load_data()" :disabled="loading || runDisabled">Run</b-button>
    &nbsp;&nbsp;
    <b-button size="md" variant="success" :disabled="loading || runDisabled" @click="download">Download</b-button>
  </div>

  <div v-if="has_run && !loading" class="multiday-otp-filter-chips actuals-filter-chips">
    <span
      class="actuals-chip actuals-chip-clickable actuals-chip-total"
      :class="{ 'actuals-chip-selected': selected_status == null }"
      @click="filter_by_status(null)"
    >{{ items.length }}/{{ summary.total_cnt }}</span>
    <span class="actuals-filter-sep">|</span>
    <span class="actuals-filter-label">Diff</span>
    <span
      class="actuals-chip actuals-chip-clickable"
      :class="{ 'actuals-chip-selected': selected_status === 'total' }"
      @click="filter_by_status('total')"
    >Total {{ diffChipCount('total') }}</span>
    <span
      class="actuals-chip actuals-chip-clickable"
      :class="{ 'actuals-chip-selected': selected_status === 'start' }"
      @click="filter_by_status('start')"
    >Start {{ diffChipCount('start') }}</span>
    <span
      class="actuals-chip actuals-chip-clickable"
      :class="{ 'actuals-chip-selected': selected_status === 'finish' }"
      @click="filter_by_status('finish')"
    >Finish {{ diffChipCount('finish') }}</span>
    <span class="actuals-filter-sep">|</span>
    <span class="actuals-filter-label">Timing</span>
    <span
      class="actuals-chip actuals-chip-clickable ontime"
      :class="{ 'actuals-chip-selected': selected_status === 'ontime' }"
      @click="filter_by_status('ontime')"
    >On Time {{ ontime_items.length }}</span>
    <span
      class="actuals-chip actuals-chip-clickable early"
      :class="{ 'actuals-chip-selected': selected_status === 'early' }"
      @click="filter_by_status('early')"
    >Early {{ early_items.length }}</span>
    <span
      class="actuals-chip actuals-chip-clickable late"
      :class="{ 'actuals-chip-selected': selected_status === 'late' }"
      @click="filter_by_status('late')"
    >Late {{ late_items.length }}</span>
    <template v-if="summary.booking_types && summary.booking_types.length > 1">
      <span class="actuals-filter-sep">|</span>
      <span class="actuals-filter-label">Type</span>
      <span
        class="actuals-chip actuals-chip-clickable booking-type-filter"
        :class="{ 'actuals-chip-selected': selected_type == null }"
        @click="filter_by_type(null)"
      >All Types</span>
      <span
        v-for="type in summary.booking_types"
        :key="type"
        class="actuals-chip actuals-chip-clickable booking-type-filter"
        :class="{ 'actuals-chip-selected': selected_type == type }"
        @click="filter_by_type(type)"
      >{{ type_label(type) }}</span>
    </template>
  </div>
  </div>

  <table v-if="has_run && !loading" width="100%" border="1" cellpadding="2">
    <tr>
      <th colspan="4" style="font-size: 18px; font-weight: bold;">&nbsp;</th>
      <th style="background-color: lightgrey" colspan="3" v-for="time_field in summary.time_fields" @click="sort_dates('planned' + time_field + 'DateTime')">{{time_field}}</th>
    </tr>
    <tr>
      <th width="60px" @click="sort_numbers('charterID')">Booking ID</th>
      <th width="60px" @click="sort_strings('vehicle')">Vehicle</th>
      <th width="60px" @click="sort_strings('driver')">Driver</th>
      <th width="60px" @click="sort_strings('total_delta')">Total Diff</th>
      <template v-for="time_field in summary.time_fields">
        <th width="60px" @click="sort_dates('planned' + time_field + 'DateTime')">Planned</th>
        <th width="60px" @click="sort_dates('actual' + time_field + 'DateTime')">Actual</th>
        <th width="30px" @click="sort_numbers(time_field + 'Delta')">Diff</th>
      </template>
    </tr>
    <template v-for="(row, rowIndex) in tableRows">
      <tr v-if="row.type === 'group'" :key="'group-' + rowIndex" class="multiday-otp-group-row">
        <td :colspan="tableColspan"><strong>{{ row.label }}:</strong> {{ row.value }}</td>
      </tr>
      <tr v-else :key="'row-' + rowIndex">
        <td align="center">
          <router-link v-if="row.item.tbn_booking_hash" target="_blank" style="font-weight: bold;" :to="{ name: 'actuals_tbn', query: { booking_id: row.item.tbn_booking_hash } }">{{ row.item.bookingID }}</router-link>
          <span v-else>{{ row.item.bookingID }}</span>
        </td>
        <td align="center">
          <router-link v-if="row.item.vehicle && tripDateIso(row.item)" target="_blank" style="font-weight: bold;" :to="{ name: 'vehicle_trip_history', query: { vehicleId: row.item.vehicle, trip_date: tripDateIso(row.item) } }">{{ row.item.vehicle }}</router-link>
          <span v-else>{{ row.item.vehicle }}</span>
        </td>
        <td align="center">
          <a v-if="driverHosLink(row.item)" target="_blank" style="font-weight: bold;" :href="driverHosLink(row.item)">{{ row.item.driver }}</a>
          <span v-else>{{ row.item.driver }}</span>
        </td>
        <td v-if="row.item.total_delta && row.item.total_delta < 0" class="early">{{ row.item.total_delta }}m</td>
        <td v-else-if="row.item.total_delta && row.item.total_delta > 0" class="late">{{ row.item.total_delta }}m</td>
        <td v-else>&nbsp;</td>
        <template v-for="time_field in summary.time_fields">
          <template v-if="timeForField(row.item, time_field).field">
            <td>{{ format_local(timeForField(row.item, time_field).planned, row.item.timezone) }}</td>
            <td>{{ format_local(timeForField(row.item, time_field).actual, row.item.timezone) }}</td>
            <td v-if="timeForField(row.item, time_field).actual && timeForField(row.item, time_field).delta < 0" class="early">{{ timeForField(row.item, time_field).delta }}m</td>
            <td v-else-if="timeForField(row.item, time_field).actual && timeForField(row.item, time_field).delta > 0" class="late">{{ timeForField(row.item, time_field).delta }}m</td>
            <td v-else-if="timeForField(row.item, time_field).delta">{{ timeForField(row.item, time_field).delta }}m</td>
            <td v-else>&nbsp;</td>
          </template>
          <template v-else>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </template>
        </template>
      </tr>
    </template>
  </table>
  <div v-else-if="loading">
    <br/><br/>
    <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
  </div>
  <div v-else style="margin: 40px 30px; font-size: 18px; color: #6c757d; text-align: center;">
    <span v-if="base_required && !selected_base">Select a base, then choose a date range and thresholds and click <strong>Run</strong> to load results.</span>
    <span v-else>Select a date range and thresholds, then click <strong>Run</strong> to load results.</span>
  </div>
</div>

</template>
<script>
import {api_url, get_booking_bases, get_tbn_multiday_otp_report } from '../networking/tbn_apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'actuals_multiday_otp_report_tbn',

  components: {
  },

  data() {
    return {
      booking_filter: '',
      items: [],
      raw_results: [],
      ontime_items: [],
      early_items: [],
      late_items: [],
      base_options: [],
      base_required: false,
      summary: [],
      day_threshold: 1,
      consecutive_days_mode: 'vehicle',
      consecutiveDaysModeOptions: [
        { value: 'vehicle', text: 'By Vehicle' },
        { value: 'driver', text: 'By Driver' },
      ],
      start_threshold: 5,
      finish_threshold: 5,
      total_threshold: 5,
      selected_status: null,
      selected_type: null,
      selected_base: '',
      daysOptions: [
        { value: '', text: '' },
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' }
      ],
      threshold_options: [
        { value: '1', text: '1m' },
        { value: '5', text: '5m' },
        { value: '10', text: '10m' },
        { value: '15', text: '15m' },
        { value: '20', text: '20m' },
        { value: '30', text: '30m' },
        { value: '45', text: '45m' },
        { value: '60', text: '1h' },
        { value: '120', text: '2h' },
        { value: '240', text: '4h' },
      ],
      loading: false,
      has_run: false,
      details_fromDate: justDate(moment().subtract(1, 'days')),
      details_toDate: justDate(moment().subtract(1, 'days')),

      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(180, 'days'),
        maxDate: moment().add(0, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    await this.load_bases()
  },
  methods: {
    async load_bases() {
      if (!this.user || !this.user.tenant) {
        return
      }
      try {
        const { value: { data = {} } } = await get_booking_bases(this.user.tenant)
        const options = (data.summary && data.summary.base_options) || []
        const yardCount = Math.max(0, options.length - 1)
        this.base_required = yardCount > 15
        if (this.base_required && options.length > 0) {
          options[0] = { ...options[0], value: '', text: 'Select Base' }
        }
        this.base_options = options
      } catch (e) {
        console.log(e)
        this.$emit('showAlert', 'error retrieving bases, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    async load_data() {
      if (this.base_required && !this.selected_base) {
        this.$emit('showAlert', 'please select a base before running the report', 'warning', 5000)
        return
      }
      this.loading = true
      try {
        const {value: {data = []}} = await get_tbn_multiday_otp_report(this.user.tenant, this.selected_base, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), this.day_threshold, this.start_threshold, this.finish_threshold, this.total_threshold, this.consecutive_days_mode)
        this.raw_results = data.results || []
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        if (this.base_options.length === 0 && data.summary && data.summary.bases) {
          this.base_options = data.summary.bases
          if (this.base_options.length > 0 && this.base_options[0].text === 'Select Base') {
            this.base_required = true
          }
        }
        this.has_run = true
        this.applyDiffFilters()
      } catch(e){
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    format_local(value, tz) {
      // tz is set per row from the booking's originating yard so multi-yard tenants render correctly;
      // falls back to the summary timezone (tenant default) for older payloads that don't carry it.
      if (!value || typeof value !== 'string') return ''
      const m = moment(String(value))
      const effective_tz = tz || (this.summary && this.summary.timezone)
      if (effective_tz) m.tz(effective_tz)
      return m.format('MM/DD hh:mm A')
    },
    timeForField(item, field) {
      return (item.times || []).find(t => t.field === field) || {}
    },
    tripDateIso(item) {
      if (!item || !item.start_day) return null
      const s = String(item.start_day)
      if (s.length !== 8) return null
      return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`
    },
    tripEndMs(item) {
      const tripDate = this.tripDateIso(item)
      if (!tripDate) return null
      const tz = (item && item.timezone) || (this.summary && this.summary.timezone)
      const dayStart = tz
        ? moment.tz(tripDate, 'YYYY-MM-DD', tz).startOf('day')
        : moment(tripDate, 'YYYY-MM-DD').startOf('day')
      return Math.floor(dayStart.valueOf()) + 43199999 + 25200000
    },
    driverHosLink(item) {
      if (item.driver_hos_link) return item.driver_hos_link
      if (!this.summary || !this.summary.org_id || !item.samsara_driver_id) return null
      const endMs = this.tripEndMs(item)
      if (endMs == null) return null
      return `https://cloud.samsara.com/o/${this.summary.org_id}/fleet/reports/hos/driver/driver/${item.samsara_driver_id}?end_ms=${endMs}`
    },
    diffMeetsThreshold(delta, threshold) {
      if (delta == null || delta === '') return false
      const value = Number(delta)
      if (Number.isNaN(value)) return false
      return Math.abs(value) >= parseInt(threshold, 10)
    },
    itemHasActuals(item) {
      return (item.times || []).some(time => time.actual != null && time.actual !== '')
    },
    itemTotalDiffMeetsThreshold(item) {
      if (!this.itemHasActuals(item)) return false
      const start = this.timeForField(item, 'Driver Start Time')
      const finish = this.timeForField(item, 'Driver Finish Time')
      if (!start.actual || !finish.actual) return false
      if (item.total_delta == null || item.total_delta === '') return false
      return this.diffMeetsThreshold(item.total_delta, this.total_threshold)
    },
    itemStartDiffMeetsThreshold(item) {
      if (!this.itemHasActuals(item)) return false
      const start = this.timeForField(item, 'Driver Start Time')
      return start.actual && this.diffMeetsThreshold(start.delta, this.start_threshold)
    },
    itemFinishDiffMeetsThreshold(item) {
      if (!this.itemHasActuals(item)) return false
      const finish = this.timeForField(item, 'Driver Finish Time')
      return finish.actual && this.diffMeetsThreshold(finish.delta, this.finish_threshold)
    },
    countSourceItems() {
      let source = (this.raw_results || []).filter(item => this.itemHasActuals(item))
      if (this.selected_type === '__other__')
        source = source.filter(item => !item.booking_type)
      else if (this.selected_type)
        source = source.filter(item => item.booking_type == this.selected_type)
      return source
    },
    itemsMatchingDiffThreshold(kind) {
      const source = this.countSourceItems()
      if (kind === 'total') return source.filter(item => this.itemTotalDiffMeetsThreshold(item))
      if (kind === 'start') return source.filter(item => this.itemStartDiffMeetsThreshold(item))
      if (kind === 'finish') return source.filter(item => this.itemFinishDiffMeetsThreshold(item))
      return source
    },
    diffChipCount(kind) {
      if (this.selected_status === kind) return this.items.length
      return this.itemsMatchingDiffThreshold(kind).length
    },
    applyDiffFilters() {
      if (!this.raw_results.length) {
        this.items_full = []
        this.items = []
        if (this.summary) {
          this.summary = { ...this.summary, total_cnt: 0 }
        }
        return
      }
      // Default view shows all success results with actual times; diff chips filter subsets.
      this.selected_status = null
      this.selected_type = null
      this.refreshFilteredPool()
    },
    refreshFilteredPool() {
      this.items_full = this.countSourceItems()
      if (this.summary) {
        this.summary = { ...this.summary, total_cnt: this.items_full.length }
      }
      this.calc_otp_status()
      this.filter_items()
    },
    async calc_otp_status() {
      for (const item of this.countSourceItems()) {
        let otp_status = ''
        let has_early = false
        let has_late = false

        if (this.itemTotalDiffMeetsThreshold(item)) {
          otp_status += '+total'
        }

        for (const time of item.times || []) {
          if (!time.actual) continue
          if (time.field === 'Driver Start Time' && this.diffMeetsThreshold(time.delta, this.start_threshold)) {
            otp_status += '+start'
            if (time.delta < 0) {
              has_early = true
            } else if (time.delta > 0) {
              has_late = true
            }
          } else if (time.field === 'Driver Finish Time' && this.diffMeetsThreshold(time.delta, this.finish_threshold)) {
            otp_status += '+finish'
            if (time.delta < 0) {
              has_early = true
            } else if (time.delta > 0) {
              has_late = true
            }
          }
        }

        if (has_early && !has_late) {
          item.otp_timing_status = 'early'
        } else if (has_late && !has_early) {
          item.otp_timing_status = 'late'
        } else if (has_early && has_late) {
          item.otp_timing_status = 'late'
        } else {
          item.otp_timing_status = 'ontime'
        }

        item.otp_status = otp_status
      }
      this.ontime_items = this.items_full.filter(item => item.otp_timing_status === 'ontime')
      this.early_items = this.items_full.filter(item => item.otp_timing_status === 'early')
      this.late_items = this.items_full.filter(item => item.otp_timing_status === 'late')
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      if (this.selected_status === 'total') {
        this.items = this.itemsMatchingDiffThreshold('total')
      } else if (this.selected_status === 'start') {
        this.items = this.itemsMatchingDiffThreshold('start')
      } else if (this.selected_status === 'finish') {
        this.items = this.itemsMatchingDiffThreshold('finish')
      } else {
        this.items = this.items_full
        if (this.selected_status === 'ontime' || this.selected_status === 'early' || this.selected_status === 'late') {
          this.items = this.items.filter(item => item.otp_timing_status === this.selected_status)
        }
      }
      if (this.booking_filter)
        this.items = this.items.filter(item => (this.contains(item.bookingID, this.booking_filter) || this.contains(item.driver, this.booking_filter) || this.contains(item.vehicle, this.booking_filter)))
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    filter_by_status(status) {
      if (status == null || this.selected_status == status) {
        this.selected_status = null
      } else {
        this.selected_status = status
      }
      this.filter_items()
    },
    filter_by_type(type) {
      this.selected_type = (type == null || this.selected_type == type) ? null : type
      this.refreshFilteredPool()
    },
    type_label(type) {
      const labels = { 'booking': 'Charter', 'charter': 'Charter', 'scheduledservice': 'Scheduled Service', 'schoolcontract': 'School Contract', '__other__': 'Other' }
      return labels[type] || type
    },
    groupSortedItems(items) {
      const key = this.consecutive_days_mode === 'driver' ? 'driver' : 'vehicle'
      return [...items].sort((a, b) => {
        const ga = String(a[key] || '')
        const gb = String(b[key] || '')
        if (ga !== gb) return ga.localeCompare(gb)
        const da = String(a.start_day || '')
        const db = String(b.start_day || '')
        if (da !== db) return da.localeCompare(db)
        return String(a.bookingID || '').localeCompare(String(b.bookingID || ''), undefined, { numeric: true })
      })
    },
    buildTableRows(items) {
      if (!this.isConsecutiveDaysMode) {
        return items.map(item => ({ type: 'row', item }))
      }
      const key = this.consecutive_days_mode === 'driver' ? 'driver' : 'vehicle'
      const label = this.consecutive_days_mode === 'driver' ? 'Driver' : 'Vehicle'
      const rows = []
      let lastGroup = null
      for (const item of this.groupSortedItems(items)) {
        const groupVal = item[key] || ''
        if (groupVal !== lastGroup) {
          rows.push({ type: 'group', label, value: groupVal })
          lastGroup = groupVal
        }
        rows.push({ type: 'row', item })
      }
      return rows
    },
    sort_dates(col) {
      console.log("sort_dates:" + col)
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a < b) {
            return -1;
          }
        })
      }
      this.sort_col = col
    },
    async download(){
      if (this.base_required && !this.selected_base) {
        this.$emit('showAlert', 'please select a base before downloading the report', 'warning', 5000)
        return
      }
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      const statusFilter = (this.selected_status === 'ontime' || this.selected_status === 'early' || this.selected_status === 'late') ? this.selected_status : null
      axios.post(
          `${api_url}tbn/reports/actuals/multiday/otp/download`,
          {
            tenant: this.user.tenant,
            base: this.selected_base,
            dayThreshold: this.day_threshold,
            consecutiveDaysMode: this.consecutive_days_mode,
            startThreshold: this.start_threshold,
            finishThreshold: this.finish_threshold,
            totalThreshold: this.total_threshold,
            status: statusFilter,
            booking_type: this.selected_type || null,
            fromDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            toDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const tenantShort = this.user.tenant.split('-')[0]
        const statusSuffix = statusFilter ? `-${statusFilter}` : ''
        link.setAttribute(
            'download',
            `actuals-multiday-otp-tbn-${tenantShort}${statusSuffix}-${this.details_fromDate}-${this.details_toDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger', 5000)
      })
    },

  },
  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
    isConsecutiveDaysMode() {
      return parseInt(this.day_threshold, 10) > 1
    },
    tableColspan() {
      const fieldCount = (this.summary && this.summary.time_fields) ? this.summary.time_fields.length : 0
      return 4 + (fieldCount * 3)
    },
    tableRows() {
      return this.buildTableRows(this.items)
    },
    runDisabled() {
      return this.base_required && !this.selected_base
    },
  },
  watch: {
    user: {
      deep: true,
      async handler() {
        this.has_run = false
        this.raw_results = []
        this.items = []
        this.items_full = []
        this.selected_base = ''
        await this.load_bases()
      }
    },
    selected_base() {
      this.has_run = false
      this.raw_results = []
      this.items = []
      this.items_full = []
      this.summary = []
    },
    total_threshold() {
      this.applyDiffFilters()
    },
    start_threshold() {
      this.applyDiffFilters()
    },
    finish_threshold() {
      this.applyDiffFilters()
    },
  }
}
</script>

<style>

.multiday-otp-filter-rows {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}
.multiday-otp-filter-row {
  position: relative;
  font-weight: bold;
  font-size: 16px;
}
.multiday-otp-filter-chips {
  margin: 0 30px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px 9px;
}
.actuals-filter-label {
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
}
.actuals-filter-sep {
  color: #adb5bd;
  margin: 0 2px;
}
.actuals-chip {
  display: inline-block;
  padding: 5px 12px;
  border: 1px solid #ccc;
  border-radius: 15px;
  font-size: 14px;
  font-weight: 600;
  background-color: #f8f9fa;
  white-space: nowrap;
}
.actuals-chip-clickable {
  cursor: pointer;
}
.actuals-chip-clickable:hover {
  opacity: 0.88;
}
.actuals-chip-selected:not(.actuals-chip-total) {
  outline: 2px solid #495057;
  outline-offset: 1px;
}
.actuals-chip-total.actuals-chip-selected {
  border: 1px solid #ccc !important;
  box-shadow: none !important;
  outline: none;
}

.early {
  background-color: hsla(120, 100%, 75%, 0.55);
  border-color: #7dcc7d;
}

.late {
  background-color: rgba(255, 0, 0, 0.2);
  border-color: #e88;
}

.ontime {
  background-color: hsla(200, 75%, 50%, 0.35);
  border-color: #6aaed6;
}
.booking-type-filter {
  background-color: hsla(250, 60%, 70%, 0.45);
  border-color: #b9b;
}

table .early {
  background-color: hsla(120, 100%, 75%, 0.2);
  border: 1px solid #000;
}

table .late {
  background-color: rgba(255, 0, 0, 0.2);
  border: 1px solid #000;
}

.multiday-otp-group-row td {
  background-color: #eee;
  font-size: 14px;
  padding: 6px 8px;
}

</style>
